import { Component, OnInit } from '@angular/core';
import { NotificationServiceService } from './../../../../../../services/notification-service/notification-service.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { RegistrosService } from './../../../../../../services/API/registros/registros.service';
import { Router } from '@angular/router';
import { GenerarDocumentoService } from './../../../../../../services/generar-documento.service';
import { StorageService } from './../../../../../../services/API/storage/storage.service';
import { ConfirmDialogComponent } from './../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { EditRegistroAdminComponent } from './components/edit-registro-admin/edit-registro-admin.component';
import { EditClasificacionComponent } from './components/edit-clasificacion/edit-clasificacion.component';
import { AuthService } from './../../../../../../services/API/auth/auth.service';
import { Location } from '@angular/common';

@Component({
    selector: 'app-registro',
    templateUrl: './registro.component.html',
    styleUrls: ['./registro.component.css'],
    standalone: false
})
export class RegistroComponent implements OnInit {

  albaran: number;
  showProgressBar: boolean = false;
  data: any = [];
  foto: string;
  errorPesajes: boolean = true;
  displayedColumns: string[] = ['residuo', 'peso1', 'peso2', 'neto', 'clasificadoPesoTotal', 'total'];
  dataSource: any = [];
  movimientos: any = [];

  constructor(private route: ActivatedRoute, public authService: AuthService, private dialog: MatDialog, private notificationService: NotificationServiceService, private registrosService: RegistrosService
              ,  private storageService: StorageService, private documento: GenerarDocumentoService, public router: Router, private location: Location) { }

  ngOnInit(): void {
    this.userRolCheckMain('permiso_registros');
    this.albaran = parseInt(this.route.snapshot.paramMap.get("id"));
    if(this.albaran > 0){
      this.getDatosRegistro();
    }
  }

  userRolCheckMain(permission: string){
    if(!this.authService.userRolCheck(permission)) {
      this.authService.logout();
    }
  }

  userRolCheck(permission: string){
    return this.authService.userRolCheck(permission);
  }

  getDatosRegistro() {
    this.showProgressBar = true;
    this.registrosService.getDatosRegistro(this.albaran, 'info').subscribe(result => {
      this.showProgressBar = false;
      this.data = result;
      this.processPesajesResiduos(this.data);
    });
  }

  generarDocumento(clasificado: boolean = false) {
    this.showProgressBar = true;
    this.registrosService.getDatosRegistro(this.albaran, 'doc').subscribe({
      next: (result) => {
        this.showProgressBar = false;
        const built = this.buildResumenFromDatos(result);
        if (built.error) {
          this.notificationService.openSnackBar('No se pudo generar el resumen del documento');
          return;
        }
        this.documento.generarDoc(this.albaran.toString(), result, built.resumen, clasificado);
      },
      error: () => {
        this.showProgressBar = false;
        this.notificationService.openSnackBar('No se pudo generar el documento');
      }
    });
  }

  downloadBase64File(contentBase64, fileName) {
      //const linkSource = `data:application/pdf;base64,${contentBase64}`;
      const linkSource = contentBase64;
      const downloadLink = document.createElement('a');
      document.body.appendChild(downloadLink);
      downloadLink.href = linkSource;
      downloadLink.target = '_self';
      downloadLink.download = fileName;
      downloadLink.click();
  }

  descargarImagen(id: number, tipo: string) {
    this.showProgressBar = true;
    this.storageService.downloadImage(id, tipo).subscribe((response: any) => {
      if(response['status'] === 'ok'){
        var a = document.createElement("a");
        a.href = response['image'];
        a.download = tipo === 'info' ? 'Pesaje_con_info.jpg' : 'Pesaje_original.jpg';
        a.click();
        this.showProgressBar = false;
        this.notificationService.openSnackBar("¡Foto descargada!");
      }else{
        this.notificationService.openSnackBar("¡Se ha producido un error!");
      }
    }, error => {
      this.showProgressBar = false;
    });
  }

  puntuarPeso(peso: string) {
    return peso.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
  }

  numSize(num, size) {
    num = num.toString();
    while (num.length < size) num = "0" + num;
    return num;
  }

  deleteAlbaran(){
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar albarán', body: '¿Seguro que deseas eliminar el albarán y todos sus pesajes? ¡También se eliminarán las fotos asociadas!'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        var albaran = this.data[0]['albaran'];
        this.registrosService.deleteAlbaran(albaran).subscribe(() => {
          this.notificationService.openSnackBar("¡Albarán eliminado correctamente!");
          this.showProgressBar = false;
          this.router.navigateByUrl('/ver-registros');
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  eliminarPesaje(id: string){
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar pesaje', body: '¿Seguro que deseas eliminar este pesaje? ¡También se eliminará la foto asociada!'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.registrosService.deletePesaje(id).subscribe(() => {
          this.notificationService.openSnackBar("¡Pesaje eliminado correctamente!");
          this.showProgressBar = false;
          this.ngOnInit();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  modificarPesaje(id: number) {
    for (var i = 0; i < this.data.length; i++) {
      if(this.data[i]["id"] === id){
        const modifDialog = this.dialog.open(EditRegistroAdminComponent, {
          data: {'id': this.data[i]["id"], 'fecha' : this.data[i]["fecha"], 'hora' : this.data[i]["hora"], 'id_camion' : this.data[i]["id_camion"], 'id_usuario' : this.data[i]["id_usuario"],
                'id_material' : this.data[i]["id_material"], 'peso' : this.data[i]["peso"], 'descripcion' : this.data[i]["descripcion"], 'albaran' : this.data[i]["albaran"]},
          width: '90%',
          maxWidth: '500px'
        });
        modifDialog.afterClosed().subscribe(result => {
          if(result){
            this.showProgressBar = true;
            this.registrosService.editPesaje(id, result["descripcion"], result["fechaFinal"], result["hora"], result["material"], result["matricula"], result["nAlbaran"], result["peso"], result["usuario"]).subscribe({
              next: () => {
                this.notificationService.openSnackBar("Pesaje modificado correctamente!");
                this.showProgressBar = false;
                this.ngOnInit();
              },
              error: () => {
                this.notificationService.openSnackBar("¡Se ha producido un error!");
                this.showProgressBar = false;
              }
            });
          }
        });
        break;
      }
    }
  }

  processPesajesResiduos(data: any){
    const built = this.buildResumenFromDatos(data);
    this.errorPesajes = built.error;
    this.dataSource = built.resumen;
  }

  private buildResumenFromDatos(data: any): { resumen: any[]; error: boolean } {
    let error = false;
    for (let i = 0; i < data.length; i++) {
      let countElements = 0;
      for (let j = 0; j < data.length; j++) {
        if (data[i]['id_material'] === data[j]['id_material']) {
          countElements++;
        }
      }
      if (countElements > 2) {
        error = true;
        break;
      }
    }

    if (error) {
      return { resumen: [], error: true };
    }

    const resumen: any[] = [];
    const hechos: number[] = [];
    for (let k = 0; k < data.length; k++) {
      if (hechos.includes(data[k]['id_material'])) {
        continue;
      }
      hechos.push(data[k]['id_material']);

      let residuo = '';
      let peso1 = -1;
      let peso2 = -1;
      for (let l = 0; l < data.length; l++) {
        if (data[k]['id_material'] === data[l]['id_material']) {
          if (residuo.length === 0) {
            residuo = data[l]['material'];
            peso1 = parseInt(data[l]['peso'], 10);
          } else {
            peso2 = parseInt(data[l]['peso'], 10);
          }
        }
      }

      let clasificadoPesoTotal = 0;
      for (let l = 0; l < data[k]['clasificado'].length; l++) {
        clasificadoPesoTotal += parseInt(data[k]['clasificado'][l]['peso'], 10);
      }

      if (peso2 === -1) {
        peso2 = 0;
      }

      const neto = peso1 >= peso2 ? peso1 - peso2 : peso2 - peso1;
      const entry = {
        residuo,
        peso1: this.puntuarPeso((peso1 >= peso2 ? peso1 : peso2).toString()),
        peso2: this.puntuarPeso((peso1 >= peso2 ? peso2 : peso1).toString()),
        neto: this.puntuarPeso(neto.toString()),
        clasificado: data[k]['clasificado'],
        clasificadoPesoTotal: this.puntuarPeso(clasificadoPesoTotal.toString()),
        total: this.puntuarPeso((neto - clasificadoPesoTotal).toString()),
      };
      resumen.push(entry);
    }

    return { resumen, error: false };
  }

  modificarClasificacion(id: number, residuoClasificado: string, peso: string, descripcion: string, residuo: number) {
    const modifDialog = this.dialog.open(EditClasificacionComponent, {
      data: {'id': id, 'residuoClasificado' : residuoClasificado, 'peso' : peso, 'descripcion' : descripcion},
      width: '90%',
      maxWidth: '500px'
    });
    modifDialog.afterClosed().subscribe(result => {
      if(result){
        this.showProgressBar = true;
        this.registrosService.editClasificacion(id,result["materiall"], result["peso"], result["observaciones"], result["foto1"], result["foto2"], this.albaran, residuo).subscribe(() => {
          this.notificationService.openSnackBar("Registro creado correctamente!");
          this.showProgressBar = false;
          this.ngOnInit();
        });
      }
    });
  }

  deleteClasificacion(id: number){
    const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
      data: {title: 'Eliminar clasificación', body: '¿Seguro que deseas eliminar la clasificación? ¡También se eliminarán las fotos asociadas!'},
      width: '90%',
      maxWidth: '350px'
    });
    confirmDialog.afterClosed().subscribe(result => {
      if(result["accion"] === 'true'){
        this.showProgressBar = true;
        this.registrosService.deleteClasificacion(id).subscribe(() => {
          this.notificationService.openSnackBar("¡Clasificación eliminada correctamente!");
          this.showProgressBar = false;
          this.ngOnInit();
        }, error => {
          this.notificationService.openSnackBar("¡Se ha producido un error!");
          this.showProgressBar = false;
        });
      }
    });
  }

  back(){
    this.location.back();
  }

}
